import { render, staticRenderFns } from "./Normativity.vue?vue&type=template&id=62a10b2c&scoped=true&lang=pug&"
import script from "./Normativity.vue?vue&type=script&lang=js&"
export * from "./Normativity.vue?vue&type=script&lang=js&"
import style0 from "./Normativity.vue?vue&type=style&index=0&id=62a10b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a10b2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62a10b2c')) {
      api.createRecord('62a10b2c', component.options)
    } else {
      api.reload('62a10b2c', component.options)
    }
    module.hot.accept("./Normativity.vue?vue&type=template&id=62a10b2c&scoped=true&lang=pug&", function () {
      api.rerender('62a10b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/virtualrow/Normativity.vue"
export default component.exports